import { render, staticRenderFns } from "./SearchLabelModal.vue?vue&type=template&id=26b5ab60&"
import script from "./SearchLabelModal.vue?vue&type=script&lang=ts&"
export * from "./SearchLabelModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports